import FlagSa from '/src/assets/images/flag/icon-flag-sa.svg';
import FlagEn from '/src/assets/images/flag/icon-flag-en.svg';
import earthFlag from '/src/assets/images/flag/icon-earth-w.svg';


export const LanguageData = [
  {
    id: 1,
    flagname: 'English',
    icon: FlagEn,
  },
  {
    id: 5,
    flagname: 'Arabic',
    icon: FlagSa,
  },
];

export const Languages = [
  {
    flagname: 'English (UK)',
    name: 'EN',
    icon: earthFlag,
    value: 'en',
  },
  {
    flagname: 'عربي (Arabic)',
    name: 'عربي',
    icon: earthFlag,
    value: 'ar',
  },
];
